import "./bootstrap.js";
import "./product.js";

import Swiper from "swiper";
import { Navigation, Pagination, EffectCreative } from "swiper/modules";

function init() {
  /**
   * Product Slider
   */
  const productSliders = document.querySelectorAll(".products-swiper");
  productSliders.forEach((element) => {
    const slidesPerView = element.dataset.perView ? element.dataset.perView : 4;
    const swiper = new Swiper(element, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: slidesPerView,
          spaceBetween: 30,
        },
      },
    });
  });

  /**
   * Testimonial Slider
   */
  const testimonialSliders = document.querySelectorAll(".testimonials-swiper");
  testimonialSliders.forEach((element) => {
    const slidesPerView = element.dataset.perView ? element.dataset.perView : 4;
    const swiper = new Swiper(element, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: slidesPerView,
          spaceBetween: 30,
        },
      },
    });
  });

  /**
   * Team Slider
   */
  const teamSliders = document.querySelectorAll(".team-swiper-wrap");
  teamSliders.forEach((element) => {
    const swiperEL = element.querySelector(".swiper");
    new Swiper(swiperEL, {
      modules: [Navigation, EffectCreative],
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: element.querySelector(".swiper-button-next"),
        prevEl: element.querySelector(".swiper-button-prev"),
      },
    });
  });
}

// Init JS function
document.addEventListener("DOMContentLoaded", (event) => {
  init();
});

// Jquery
jQuery(document).ready(function ($) {
  $(".feature-block").mouseenter(function () {
    $(this).css("overflow", "hidden");
    const $icon = $(this).find(".feature-block-icon");
    const $iconIn = $(this).find(".feature-block-icon-in img");
    $icon.animate(
      {
        translateY: 0,
        scale: 30,
      },
      200,
      "linear"
    );
    $iconIn.animate(
      {
        height: "88px",
        opacity: 1,
      },
      250,
      "linear"
    );
  });
  $(".feature-block").mouseleave(function () {
    const $icon = $(this).find(".feature-block-icon");
    const $iconIn = $(this).find(".feature-block-icon-in img");
    const $block = $(this);
    $iconIn.animate(
      {
        height: 0,
        opacity: 0,
      },
      100,
      "linear"
    );
    $icon.animate(
      {
        translateY: -20,
        scale: 1,
      },
      100,
      "linear",
      function () {
        console.log(this);
        $block.css("overflow", "unset");
      }
    );
  });
});

const rotatingElement = document.getElementById("artworkText");
if (rotatingElement) {
  let isVisible = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isVisible = entry.intersectionRatio > 0;
      });
    },
    {
      threshold: 0,
    }
  );

  observer.observe(rotatingElement);

  window.addEventListener("scroll", () => {
    if (isVisible) {
      const scrollPosition = window.pageYOffset;
      const rotationAngle = scrollPosition / 6;
      rotatingElement.style.transform = `rotate(${rotationAngle}deg)`;
    }
  });
}

const curateYourStack = document.querySelectorAll(".curate-your-stack");
if (curateYourStack.length) {
  curateYourStack.forEach((section) => {
    const swiperEl = section.querySelector(".scriptlab-elementor-slider");
    const swiperPagination = section.querySelector(".swiper-pagination");
    const prev = section.querySelector(".swiper-button-prev");
    const next = section.querySelector(".swiper-button-next");

    swiperEl.addEventListener("scriptlab_swiper_on_init", function (event) {
      const swiperInstance = event.detail.swiper;

      Object.assign(swiperInstance.params.navigation, {
        prevEl: prev,
        nextEl: next,
      });

      Object.assign(swiperInstance.params.pagination, {
        el: swiperPagination,
      });

      if (swiperInstance.navigation) {
        swiperInstance.navigation.destroy();
        swiperInstance.navigation.init();
        swiperInstance.navigation.update();
      }

      if (swiperInstance.pagination) {
        swiperInstance.pagination.destroy();
        swiperInstance.pagination.init();
        swiperInstance.pagination.render();
        swiperInstance.pagination.update();
      }

      swiperInstance.update();
    });
  });
}

const navAccountToggle = document.querySelector(
  ".menu-account-item.logged-out"
);
const authModal = document.querySelector(".auth-modal");
if (navAccountToggle && authModal) {
  navAccountToggle.addEventListener("click", function (e) {
    e.preventDefault();

    if (authModal.classList.contains("active")) {
      authModal.classList.remove("active");
    } else {
      authModal.classList.add("active");
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("menu-account-item")) return;
    if (!authModal.classList.contains("active")) return;

    const modalContent = authModal.querySelector(".auth-modal-body");

    if (authModal && modalContent && !modalContent.contains(event.target)) {
      // The click was outside the modal content
      // Close the modal here
      authModal.classList.remove("active");
    }
  });
}


